@import '../../../global/global.pcss';
@import '../../common/search-box/search-box.pcss';

[part~='instant-results-item'] {
  @apply p-3;
}

[part~='instant-results-show-all'] {
  @apply justify-center py-1;
  border-top: 1px solid var(--atomic-neutral);
  margin-top: auto;
  box-sizing: content-box;
  button {
    background-color: transparent;
  }
}

[part~='suggestions-left'] + [part~='suggestions-right'] {
  border-left: 1px solid var(--atomic-neutral);
}

[part~='suggestions-wrapper'] {
  flex-direction: column;
  @media only screen and (min-width: 1024px) {
    flex-direction: row;
  }
}

:host([textarea]) {
  @apply relative z-10;
}
